import "./App.css";

function App() {
  return (
    <div className="App">
      <p>Hello </p>
    </div>
  );
}

export default App;
